import React, { useRef } from "react";
import { ChevronLeft, ChevronRight, ArrowRight } from "lucide-react";
import { PropertyCard } from "./PropertyCard";
import { VibeBadges } from "./HomeLiveElements";

export const PropertySection = ({ title, properties = [], query = "", geoById = {}, nights = 0, testid = "property-section" }) => {
  const scroller = useRef(null);
  const by = (dir) => {
    const el = scroller.current;
    if (el) el.scrollBy({ left: dir * Math.max(el.clientWidth * 0.85, 260), behavior: "smooth" });
  };
  if (properties.length === 0) return null;
  const secGeo = properties.map((p) => geoById[p.id]).find((g) => g && g.lat != null && g.lng != null);

  return (
    <section className="mb-12" data-testid={testid}>
      <div className="flex items-end justify-between gap-4 mb-4">
        <div className="flex items-center min-w-0">
          <h2 className="group inline-flex items-center gap-2.5 font-heading font-extrabold text-[1.35rem] md:text-[1.7rem] tracking-tight text-ink">
            {title}
            <span className="w-8 h-8 shrink-0 rounded-full bg-paper-muted md:bg-transparent flex items-center justify-center">
              <ArrowRight className="w-4 h-4 md:w-5 md:h-5 text-ink md:text-brand group-hover:translate-x-1 transition-transform" aria-hidden="true" />
            </span>
          </h2>
          <VibeBadges lat={secGeo?.lat} lng={secGeo?.lng} />
        </div>
        <div className="hidden md:flex items-center gap-2">
          <button onClick={() => by(-1)} aria-label="Scroll left" data-testid={`${testid}-prev`}
            className="w-9 h-9 rounded-full border border-black/10 bg-white flex items-center justify-center text-ink hover:border-brand hover:text-brand transition-colors">
            <ChevronLeft className="w-4 h-4" />
          </button>
          <button onClick={() => by(1)} aria-label="Scroll right" data-testid={`${testid}-next`}
            className="w-9 h-9 rounded-full border border-black/10 bg-white flex items-center justify-center text-ink hover:border-brand hover:text-brand transition-colors">
            <ChevronRight className="w-4 h-4" />
          </button>
        </div>
      </div>

      <div ref={scroller} className="flex gap-5 overflow-x-auto no-scrollbar snap-x snap-mandatory -mx-5 px-5 md:mx-0 md:px-0 pb-1">
        {properties.map((p, i) => (
          <div key={p.id} className="snap-start shrink-0 w-[78vw] sm:w-[300px] lg:w-[310px]">
            <PropertyCard property={p} index={i} query={query} locationOverride={geoById[p.id]} nights={nights} />
          </div>
        ))}
      </div>
    </section>
  );
};

export default PropertySection;
